// SPDX-License-Identifier: EPL-2.0

const panelAsideHiddenKey = 'panel.aside.hidden'
const HIDDEN = 'true'

/**
 * @public
 */
export function isPanelAsideHidden (): boolean {
  try {
    return localStorage.getItem(panelAsideHiddenKey) === HIDDEN
  } catch {
    return false
  }
}

/**
 * @public
 */
export function setPanelAsideHidden (hidden: boolean): void {
  try {
    hidden ? localStorage.setItem(panelAsideHiddenKey, HIDDEN) : localStorage.removeItem(panelAsideHiddenKey)
  } catch {}
}

/**
 * Resolve the initial aside state of a panel, taking the remembered user choice into account.
 * Custom asides (tabs) and explicitly requested states (false or a tab id) are kept as is.
 * @public
 */
export function getInitialPanelAside (
  selectedAside: string | boolean,
  hasCustomAside: boolean,
  hidden: boolean
): string | boolean {
  if (hasCustomAside || selectedAside === false || typeof selectedAside === 'string') return selectedAside
  return hidden ? false : selectedAside
}
